/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type app_v1_positions_PositionsArgs = {
    account_ids?: string;
    columns?: string;
    grouping?: app_v1_positions_PositionsArgs.grouping;
    include_cash?: boolean;
};

export namespace app_v1_positions_PositionsArgs {

    export enum grouping {
        INSTRUMENT = 'instrument',
    }


}

